export const I2G_MONEY_PAYMENT_ACTIVITY_TUTORIAL_COOKIE =
  'i2g_money_payment_activity';

export interface I2gMoney {
  webview: I2gMoneyWebview;
  context: I2gMoneyContext;
  accountSummary: I2gMoneyAccountSummary;
  statements: I2gMoneyStatement[];
}

export interface I2gMoneyWebview {
  url: string;
  encrypted_account_id: string;
}

export enum I2gMoneyApplicationStatusEnum {
  not_applied = 'not_applied',
  awaiting_documents = 'awaiting_documents',
  pending_review = 'pending_review',
  approved = 'approved',
  denied = 'denied',
}

export enum I2gMoneyApplicationDocumentTypeEnum {
  driver_license_front = 'driver_license_front',
  driver_license_back = 'driver_license_back',
  passport = 'passport',
  utility_bill = 'utility_bill',
  social_security_card = 'social_security_card',
  certificate_of_incorporation = 'certificate_of_incorporation',
  ein_confirmation = 'ein_confirmation',
}

export enum I2gMoneyApplicationDocumentStatusEnum {
  required = 'required',
  pending_review = 'pending_review',
  approved = 'approved',
  invalid = 'invalid',
}

export interface I2gBankAccount {
  name: string;
  routing_number: string;
  account_number: string;
  currency: string;
}

export interface ExternalBankAccount {
  name: string;
  routing_number: string;
  account_number: string;
  currency: string;
  bank: string;
  logo: string;
}

export interface I2gMoneyContext {
  settings: {
    allowed_by_partner: boolean;
    enabled_by_user: boolean;
    completed_onboarding: boolean;
  };
  application: {
    status: I2gMoneyApplicationStatusEnum;
    documents: [
      {
        id: string;
        type: I2gMoneyApplicationDocumentTypeEnum;
        status: I2gMoneyApplicationDocumentStatusEnum;
        applicant_name: string;
        rejection_reason: string | null;
      }
    ];
  };
  partner_bank_account: I2gBankAccount;
  external_bank_account: ExternalBankAccount;
}

export interface I2gMoneyStatement {
  id: string;
  period: string;
}

export enum I2gMoneyTransactionDirection {
  debit = 'debit',
  credit = 'credit',
}

export interface I2gMoneyTransactionDocument {
  document_id: string;
  document_type: string;
  document_number: string;
  client_name: string;
}

export interface I2gMoneyTransaction {
  id: string;
  type: string;
  created_date: string;
  direction: I2gMoneyTransactionDirection;
  amount: number;
  description: string;
  currency: string;
  document: I2gMoneyTransactionDocument;
}

export interface I2gMoneyBankAccountSummary {
  balance: number;
  hold: number;
  available: number;
}

export interface I2gMoneyAccountSummary {
  partner_bank_account_summary: I2gMoneyBankAccountSummary;
  transactions: I2gMoneyTransaction[];
}
